import { FeatureFlag } from '../FeatureFlag';

export const enableNewManualReviewColumns = new FeatureFlag({
    key: 'enable-new-manual-review-columns',
    createdOn: '2026-02-09',
    defaultValue: false,
});
